<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="storeTemplate">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4 class="text-capitalize">{{ title }}</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>

                    <div v-if="type.toLowerCase() === 'geofence'">
                        <v-row>
                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="geofenceFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              autofocus density="compact" label="Label" placeholder="New Real-Time Geo Fence Name"/>
                            </v-col>
                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="geofenceFormData['trigger_delay']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Trigger delay" placeholder="300" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="geofenceFormData['minimum_violation_time']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Min. violation time" placeholder="10" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12">
                                <v-select v-model="geofenceFormData['enter_or_exit']"
                                          :items="[
                                              {value:1,title:'Enter Only'},
                                              {value:2,title:'Exit Only'},
                                              {value:3,title:'Both'},
                                          ]" :rules="[vRules.required]"
                                          density="compact" label="Report violation event" placeholder="Both"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'light'">
                        <v-row>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="lightSensorFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]" autofocus density="compact"
                                              label="Label" placeholder="New Light Sensor Template"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="lightSensorFormData['lux_value']"
                                              :rules="[vRules.required]" density="compact" label="LUX Value"
                                              placeholder="1000" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="lightSensorFormData['light_profile']"
                                          :items="[
                                              {value:1, title: 'Low Sensitivity'},
                                              {value:2, title: 'Normal'},
                                              {value:3, title: 'High Sensitivity'},
                                              ]" :rules="[vRules.required]"
                                          density="compact" label="Light Profile" placeholder="Normal"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="lightSensorFormData['debounce_interval_in_seconds']"
                                          :items="[1,2,3,4,5,6,7,8,9,10]"
                                          :rules="[vRules.required]"
                                          density="compact" label="Debounce time in seconds" placeholder="3"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="lightSensorFormData['reporting_interval_in_seconds']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Minimum Delay between multiple alerts (in seconds)"
                                              placeholder="300"
                                              type="number"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-switch v-model="lightSensorFormData['light_to_dark']" color="primary"
                                          density="compact" label="Light to dark"/>
                            </v-col>

                            <v-col cols="6">
                                <v-switch v-model="lightSensorFormData['dark_to_light']" color="primary"
                                          density="compact" label="Dark to light"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'temperature'">
                        <v-row>
                            <v-col cols="6">
                                <v-switch v-model="temperatureSensorFormData['low_reporting_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="Low Reporting Status"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-switch v-model="temperatureSensorFormData['high_reporting_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="High Reporting Status"
                                />
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="temperatureSensorFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]" autofocus density="compact"
                                              label="Label" placeholder="Temperature change monitoring "/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="temperatureSensorFormData['low_threshold_celsius']"
                                              :rules="[vRules.required]"
                                              density="compact" label="Low threshold in celsius" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="temperatureSensorFormData['high_threshold_celsius']"
                                              :rules="[vRules.required]"
                                              density="compact" label="High threshold in celsius" type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="temperatureSensorFormData['debounce_interval_in_seconds']"
                                          :items="[1,2,3,4,5,6,7,8,9,10]"
                                          :rules="[vRules.required]"
                                          density="compact" label="Debounce time in seconds"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="temperatureSensorFormData['reporting_interval_in_seconds']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Minimum Delay between multiple alerts (in seconds)"
                                              type="number"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'ble_tag' || type.toLowerCase() === 'wifi_tag'">
                        <v-row>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              autofocus density="compact" label="Label" placeholder="New BLE tag Scan"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['scan_interval_in_seconds']"
                                              :rules="[vRules.required]" density="compact" hint="Seconds"
                                              label="Scan interval" placeholder="30" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['scan_window_in_seconds']"
                                              :rules="[vRules.required]" density="compact" hint="Seconds"
                                              label="Scan window" placeholder="10" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['minimum_rssi_threshold']"
                                              :rules="[vRules.required]" density="compact" hint="dBm"
                                              label="Minimum RSSI" placeholder="-65" type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="bleWifiFormData['debounce_interval_in_seconds']"
                                          :items="[1,2,3,4,5,6,7,8,9,10]"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Debounce time in seconds" placeholder="5"
                                />
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['reporting_interval_in_seconds']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Minimum Delay between multiple alerts (in seconds)"
                                              placeholder="300"
                                              type="number"
                                />
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-combobox
                                    v-model="bleWifiFormData['name_prefixes']"
                                    :items="[]"
                                    :rules="[vRules.required]"
                                    chips
                                    hint="Press Enter after prefix"
                                    label="Name Prefixes"
                                    placeholder="NB-"
                                    multiple
                                ></v-combobox>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-combobox
                                    v-model="bleWifiFormData['address_prefixes']"
                                    hint="Please enter in xx:xx:xx format and press Enter"
                                    :items="[]"
                                    :rules="[vRules.required]"
                                    chips
                                    persistent-hint
                                    @update:model-value="validateFormat"
                                    label="Address Prefixes"
                                    placeholder="08:20:39"
                                    multiple
                                ></v-combobox>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-checkbox v-model="bleWifiFormData['driver_id_scan']"
                                            label="Driver ID Scan"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-checkbox v-model="bleWifiFormData['report_on_change']"
                                            label="Report only on changes"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'speed'">
                        <v-row>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="speedFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              autofocus density="compact" label="Label" placeholder="New Speed Template"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="speedFormData['speed_threshold']" :rules="[vRules.required]"
                                              density="compact" :label="`Speed Threshold (${speedUnitLabel})`" placeholder="85" type="number"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="speedFormData['minimum_violations_in_seconds']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Minimum Violations in Seconds" placeholder="10" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="speedFormData['minimum_alert_interval_seconds']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Minimum Alert interval Seconds" placeholder="300" type="number"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'push_button'">
                        <v-row>
                            <v-col class="py-0" cols="6">
                                <v-checkbox v-model="pushButtonFormData['report_press']" label="Report Press"/>
                            </v-col>
                            <v-col class="py-0" cols="6">
                                <v-checkbox v-model="pushButtonFormData['report_release']" label="Report Release"/>
                            </v-col>

                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="pushButtonFormData['label']"
                                              :rules="[vRules.required]" autofocus density="compact" label="Label"/>
                            </v-col>

                            <v-col class="py-0" cols="6">
                                <v-text-field v-model="pushButtonFormData['debounce_interval']"
                                              :rules="[vRules.required]" density="compact" label="Debounce Interval"/>
                            </v-col>
                            <v-col class="py-0" cols="6">
                                <v-text-field v-model="pushButtonFormData['report_interval']"
                                              :rules="[vRules.required]" density="compact" label="Report Interval"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'io'">
                        <v-row>
                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="extGpioFormData['label']"
                                              :rules="[vRules.required, vRules.maxLength(64)]" autofocus
                                              density="compact" label="Template name"
                                              placeholder="e.g. Beacon while moving"/>
                            </v-col>

                            <v-col class="pb-0 pt-3" cols="12">
                                <h4 class="text-subtitle-1">Digital Output</h4>
                                <p class="text-caption text-medium-emphasis mb-1">
                                    The line the tracker drives. Wire it to a relay, LED, buzzer or beacon.
                                </p>
                                <v-checkbox v-model="extGpioFormData['gpo']" density="compact" hide-details
                                            label="Enable digital output"/>
                            </v-col>

                            <v-col v-if="extGpioFormData['gpo']" class="py-0" cols="12">
                                <IoFunctionPicker :model-value="extGpioFormData"
                                                  @update:fields="onIoFunctionChange"/>
                            </v-col>

                            <v-col v-if="extGpioFormData['gpo']" class="py-0" cols="12">
                                <v-expansion-panels variant="accordion">
                                    <v-expansion-panel title="Advanced output settings">
                                        <v-expansion-panel-text>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select v-model="extGpioFormData['gpo_default_state']"
                                                              :items="[
                                                                  {value: true, title: 'Active high (most loads)'},
                                                                  {value: false, title: 'Active low (inverted)'},
                                                              ]"
                                                              density="compact"
                                                              label="Output polarity"
                                                              hint="Most loads turn on when the wire is driven high. Pick active low only if your load is normally on."
                                                              persistent-hint/>
                                                </v-col>
                                                <v-col v-if="ioPickerAdvanced" class="py-1" cols="6">
                                                    <v-text-field v-model.number="extGpioFormData['ext_gpi_motion_period_ms']"
                                                                  :min="0" :max="65535"
                                                                  density="compact" type="number"
                                                                  label="Pulse period (ms)"
                                                                  hint="100 to 65535, or 0 for default"
                                                                  persistent-hint/>
                                                </v-col>
                                                <v-col v-if="ioPickerAdvanced" class="py-1" cols="6">
                                                    <v-text-field v-model.number="extGpioFormData['ext_gpi_motion_pulse_width_ms']"
                                                                  :min="0" :max="65535"
                                                                  density="compact" type="number"
                                                                  label="Pulse width (ms)"
                                                                  hint="10 ms minimum, must be less than period"
                                                                  persistent-hint/>
                                                </v-col>
                                                <v-col v-if="ioPickerAdvanced" class="py-1" cols="12">
                                                    <v-row>
                                                        <v-col cols="3">
                                                            <v-checkbox v-model="extGpioFormData['ext_gpi_idle_state']"
                                                                        :true-value="1" :false-value="0"
                                                                        density="compact" hide-details
                                                                        label="Idle state ON"/>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-checkbox v-model="extGpioFormData['ext_gpi_motion_pulse_start']"
                                                                        :true-value="1" :false-value="0"
                                                                        density="compact" hide-details
                                                                        label="Pulse on start"/>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-checkbox v-model="extGpioFormData['ext_gpi_motion_pulse_stop']"
                                                                        :true-value="1" :false-value="0"
                                                                        density="compact" hide-details
                                                                        label="Pulse on stop"/>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-select v-model="extGpioFormData['ext_gpi_motion_during']"
                                                                      :items="[
                                                                          {value: 0, title: 'None'},
                                                                          {value: 1, title: 'Sustain'},
                                                                          {value: 2, title: 'Pulse'},
                                                                      ]"
                                                                      density="compact" hide-details
                                                                      label="During motion"/>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <p class="text-caption text-medium-emphasis mt-1 mb-0">
                                                                Tip: when Idle state is ON, pulse presets produce a brief LOW dip instead of a HIGH spike.
                                                            </p>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>

                            <v-col class="pb-0 pt-3" cols="12">
                                <h4 class="text-subtitle-1">Digital Input</h4>
                                <p class="text-caption text-medium-emphasis mb-1">
                                    The line the tracker reads. Wire it to a switch, sensor, or ignition feed.
                                </p>
                                <v-checkbox v-model="extGpioFormData['gpi']" density="compact" hide-details
                                            label="Enable digital input"/>
                            </v-col>

                            <v-col v-if="extGpioFormData['gpi']" class="py-0" cols="12">
                                <v-select v-model="extGpioFormData['ext_gpo_notify_on_edge']"
                                          :items="[
                                              {value: 0, title: 'Either change (signal turns on or off)'},
                                              {value: 1, title: 'Signal turns on'},
                                              {value: 2, title: 'Signal turns off'},
                                          ]"
                                          density="compact" label="Send a notification when"/>
                            </v-col>

                            <v-col v-if="extGpioFormData['gpi']" class="py-0" cols="12">
                                <v-expansion-panels variant="accordion">
                                    <v-expansion-panel title="Advanced input settings">
                                        <v-expansion-panel-text>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select v-model="extGpioFormData['ext_gpo_active_level']"
                                                              :items="[
                                                                  {value: 0, title: 'No (signal is on when the wire is high)'},
                                                                  {value: 1, title: 'Yes (signal is on when the wire is low)'},
                                                              ]"
                                                              density="compact" label="Invert input polarity"/>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field v-model.number="extGpioFormData['gpi_debounce_interval']"
                                                                  :min="0"
                                                                  density="compact" type="number"
                                                                  label="Filter short pulses (ms)"
                                                                  hint="Ignore changes shorter than this"
                                                                  persistent-hint/>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field v-model.number="extGpioFormData['gpi_report_interval']"
                                                                  :min="0"
                                                                  density="compact" type="number"
                                                                  label="Cooldown between events (ms)"
                                                                  hint="Time before another event can fire"
                                                                  persistent-hint/>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <v-row>
                            <v-col cols="6">
                                <v-switch v-model="generalFormData['periodic_reboot_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="Periodic Reboot Status"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-switch v-model="generalFormData['lte_scan_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="LTE Scan Status"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-switch v-model="generalFormData['ble_scan_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="BLE Scan Status"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-switch v-model="generalFormData['wifi_scan_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="Wifi Scan Status"
                                />
                            </v-col>

                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="generalFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              autofocus density="compact" label="Label"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['network_diagnostics_status']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Network Diagnostic Status"
                                              type="number"
                                />
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gateway_timeout_in_milli_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint=" Milliseconds"
                                              label="Gateway Timeout"
                                              type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['movement_starts_alert_flag']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Movement Start Alert Flag"
                                              type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['network_registration_timeout_in_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Network Registration Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['periodic_reboot_interval_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Periodic Reboot Interval"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['server_acknowledgment_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Server Acknowledgment"
                                              type="number"/>
                            </v-col>


                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['network_diagnostics_period_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Network Diagnostic Period"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['heartbeat_packet_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Heartbeat Packet"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['movement_progress_alert_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Movement Progress Alert"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['activity_threshold_x_axes']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Activity Threshold X Axes"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['activity_threshold_y_axes']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Activity Threshold Y Axes"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['activity_threshold_z_axes']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Activity Threshold Z Axes"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['seconds_per_sample']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Seconds per sample"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['minimum_activity_interrupts_needed_per_sample']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Per sample"
                                              label="Minimum activity interrupts needed"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['fifo_size']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="FIFO Size"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['fifo_movement_start_thresholds']"
                                              @blur="updateMovementFifoThreshold"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="FIFO movement starts thresholds"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['fifo_movement_continue_thresholds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="FIFO movement continue thresholds"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gps_minimum_accuracy_idle']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Idle"
                                              label="GPS minimum accuracy (Idle)"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gps_minimum_accuracy_movement']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Movement"
                                              label="GPS minimum accuracy (Movement)"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gps_fix_timeout_idle_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Idle in seconds"
                                              label="GPS fix timeout (Idle)"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gps_fix_timeout_movement_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Movement in seconds"
                                              label="GPS fix timeout (Movement)"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['packet_retransmit_attempts']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Packet Retransmit attempts"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['lte_scan_trigger_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="LTE Scan Trigger Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['ble_scan_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="BLE Scan Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['ble_scan_trigger_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="BLE Scan Trigger Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['wifi_scan_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Wifi Scan Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['wifi_scan_trigger_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Wifi Scan Trigger Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['max_stationary_progress_interval']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Max Stationary Progress Interval"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['ble_scan_interval']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Ble Scan Interval"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['ble_scan_window']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Ble Scan Window"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['movement_instantaneous_fifo_threshold']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Movement Instantaneous FIFO Threshold"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['movement_algo_type']"
                                              density="compact"
                                              label="Movement Algo Type"
                                              type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-switch v-model="generalFormData['ignition_on_ext_gpi1']"
                                          color="primary"
                                          density="compact"
                                          hide-details
                                          label="Ignition is on EXT GPI1"/>
                                <p class="text-caption text-medium-emphasis">
                                    Orion Fleet only. The tracker watches EXT GPI1 itself, with no External I/O template attached, and reports movement for as long as the line is active.
                                </p>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="generalFormData['ignition_ext_gpi1_active_level']"
                                          :disabled="!generalFormData['ignition_on_ext_gpi1']"
                                          :items="ignitionActiveLevels"
                                          density="compact"
                                          item-title="label"
                                          item-value="value"
                                          label="EXT GPI1 Active State"/>
                            </v-col>
                        </v-row>
                    </div>

                    <v-row v-if="type.toLowerCase() === 'geofence'">
                        <v-col cols="12" style="height: 350px">
                            <l-map ref="mapContainer" :center="[47.41322,-1.219482]" :zoom="15" @ready="mapIsReady">
                                <l-tile-layer :url="$mapTiles.street"/>
                            </l-map>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import "leaflet-draw";
import L from "leaflet";
import {ref, reactive, computed} from "vue";
import IoFunctionPicker from "./IoFunctionPicker.vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {useAuthStore} from "@/stores/authStore";
import {LMap, LTileLayer} from "@vue-leaflet/vue-leaflet";
import {GeoSearchControl, OpenStreetMapProvider} from "leaflet-geosearch";
import {mapTiles} from "@/composables/mapConfig";

const props = defineProps({
    type: String,
    companyId: Number,
    modelValue: Boolean,
});
const mapContainer = ref();
const errors = ref([]);
const snackbar = useSnackbarStore();
const userPrefersKm = computed(() => useAuthStore().configs?.distance_unit === 'km');
const speedUnitLabel = computed(() => userPrefersKm.value ? 'kph' : 'mph');
/** Convert speed threshold from display unit to MPH (DB storage) */
const displayToMph = (val) => userPrefersKm.value ? Math.round(val / 1.609) : val;
const dialogSwitch = ref(props.modelValue);
const speedFormData = reactive({
    label: null,
    speed_threshold: null,
    company_id: props.companyId,
    minimum_violations_in_seconds: null,
    minimum_alert_interval_seconds: null,
});
const geofenceFormData = reactive({
    label: null,
    company_id: props.companyId,
    type: 0,
    radius: null,
    center_lat: null,
    center_lon: null,
    polygon_coordinates: null,
    trigger_delay: null,
    enter_or_exit: null,
    minimum_violation_time: null,
});
const lightSensorFormData = reactive({
    label: null,
    lux_value: null,
    company_id: props.companyId,
    light_to_dark: 1,
    dark_to_light: 1,
    debounce_interval_in_seconds: 3,
    reporting_interval_in_seconds: 300,
    light_profile: null,
});
const temperatureSensorFormData = reactive({
    label: null,
    company_id: props.companyId,
    low_reporting_status: true,
    high_reporting_status: true,
    low_threshold_celsius: -10,
    high_threshold_celsius: 40,
    debounce_interval_in_seconds: 10,
    reporting_interval_in_seconds: 300,
});
const bleWifiFormData = reactive({
    label: null,
    type: props.type === 'ble_tag' ? 'ble' : (props.type === 'wifi_tag' ? 'wifi' : null),
    company_id: props.companyId,
    scan_interval_in_seconds: null,
    scan_window_in_seconds: null,
    minimum_rssi_threshold: null,
    debounce_interval_in_seconds: null,
    reporting_interval_in_seconds: null,
    driver_id_scan: null,
    report_on_change: true,
    name_prefixes: null,
    address_prefixes: null,
});
const pushButtonFormData = reactive({
    label: null,
    report_press: false,
    report_release: false,
    debounce_interval: null,
    report_interval: null,
    company_id: props.companyId,
});
const extGpioFormData = reactive({
    label: null,
    gpi: true,
    gpo: true,
    gpo_output: false,
    gpo_default_state: true, // active-high default, matches most loads (relays, LEDs, buzzers)
    gpi_debounce_interval: 50,
    gpi_report_interval: 1000,
    // config-driven IO motion fields, zero defaults match legacy behaviour
    ext_gpi_idle_state: 0,
    ext_gpi_motion_pulse_start: 0,
    ext_gpi_motion_during: 0,
    ext_gpi_motion_pulse_stop: 0,
    ext_gpi_motion_period_ms: 0,
    ext_gpi_motion_pulse_width_ms: 0,
    ext_gpo_active_level: 0,
    ext_gpo_notify_on_edge: 0,
    company_id: props.companyId,
});
const ioPickerAdvanced = ref(false);
function onIoFunctionChange(event) {
    ioPickerAdvanced.value = !!event.advanced;
    if (event.advanced) return;
    Object.assign(extGpioFormData, event.fields);
}
// Matches the firmware's own encoding so there is one convention rather than two:
// EXT_GPO_ACTIVE_LEVEL_HIGH = 0, EXT_GPO_ACTIVE_LEVEL_LOW = 1. Active high is also
// what the firmware assumes when no External I/O config is present.
const ignitionActiveLevels = [
    {value: 0, label: 'Active High - ignition on when the line is high'},
    {value: 1, label: 'Active Low - ignition on when the line is low'},
];
const generalFormData = reactive({
    label: null,
    company_id: props.companyId,
    gateway_timeout_in_milli_seconds: 5000,
    network_registration_timeout_in_seconds: 120,
    periodic_reboot_status: false,
    periodic_reboot_interval_seconds: 0,
    server_acknowledgment_seconds: 2000,
    network_diagnostics_status: null,
    network_diagnostics_period_seconds: 28800,
    heartbeat_packet_seconds: 10800,
    movement_starts_alert_flag: 29,
    movement_progress_alert_seconds: 30,
    activity_threshold_x_axes: 33,
    activity_threshold_y_axes: 33,
    activity_threshold_z_axes: 33,
    fifo_size: 120,
    seconds_per_sample: 0,
    minimum_activity_interrupts_needed_per_sample: 1,
    fifo_movement_start_thresholds: 5,
    fifo_movement_continue_thresholds: 5,
    gps_minimum_accuracy_idle: 6,
    gps_minimum_accuracy_movement: 25,
    gps_fix_timeout_idle_seconds: 300,
    gps_fix_timeout_movement_seconds: 120,
    packet_retransmit_attempts: 3,
    lte_scan_status: true,
    lte_scan_trigger_timeout: 120,
    ble_scan_status: false,
    ble_scan_timeout: 10,
    ble_scan_trigger_timeout: 30,
    wifi_scan_status: false,
    wifi_scan_timeout: 10,
    wifi_scan_trigger_timeout: 30,
    max_stationary_progress_interval: 300,
    ble_scan_interval: 511,
    ble_scan_window: 48,
    movement_instantaneous_fifo_threshold: null,
    movement_algo_type: null,
    ignition_on_ext_gpi1: false,
    ignition_ext_gpi1_active_level: 0,
});
const urlPrefix = computed(() => {
    switch (props.type.toLowerCase()) {
        case 'geofence':
            return 'monitoring/geofence';
        case 'light':
            return 'monitoring/light-sensor'
        case 'temperature':
            return 'monitoring/temperature'
        case 'speed':
            return 'monitoring/speed'
        case 'push_button':
            return 'monitoring/push-button'
        case 'io':
            return 'monitoring/ext-gpio'
        case 'ble_tag':
        case 'wifi_tag':
            return 'monitoring/ble-wifi'
        default:
            return 'monitoring/general'
    }
});
const emits = defineEmits(['update:modelValue', 'addTemplate']);

const title = computed(() => {
    switch (props.type.toLowerCase()) {
        case 'geofence':
            return "Real-Time Geo Fence Template"
        case 'light':
            return "Light Sensor Template"
        case 'temperature':
            return "Temperature Sensor Template"
        case 'ble_tag':
            return "BLE Tag Scan template"
        case 'wifi_tag':
            return "Wifi Tag Scan template"
        case 'speed':
            return "Speed Template"
        case 'push_button':
            return "Push Button Template"
        case 'io':
            return "Input Output Template"
        default:
    }
})

const validateFormat = () => {
    if (bleWifiFormData['address_prefixes']?.length) {
        bleWifiFormData['address_prefixes'] = bleWifiFormData['address_prefixes'].filter(addr => {
            return /^(\d{2}):(\d{2}):(\d{2})$/.test(addr);
        });
    }
}
const mapIsReady = () => {
    const map = mapContainer.value.leafletObject;
    map.attributionControl.remove();
    /*Add Draw Geo Search Control*/
    const geoSearchOptions = new GeoSearchControl({
        style: "bar",
        autoClose: true,
        keepResult: true,
        showMarker: false,
        searchLabel: "Enter address",
        provider: new OpenStreetMapProvider({searchUrl: mapTiles.searchUrl, reverseUrl: mapTiles.reverseUrl}),
    });
    map.addControl(geoSearchOptions);


    /*Add Draw Tool Bar Control*/
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);
    const drawControl = new L.Control.Draw({
        draw: {
            circle: true,
            polygon: {
                showArea: true,
                allowIntersection: false, // Restricts shapes to simple polygons
                drawError: {
                    color: '#9d1212', // Color the shape will turn when intersects
                    message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
                }
            },
            // disable toolbar item by setting it to false
            marker: false,
            polyline: false,
            rectangle: false,
            circlemarker: false,
        },
        edit: {
            featureGroup: drawnItems
        }
    });
    map.addControl(drawControl);

    map.on('draw:created', function (e) {
        drawnItems.eachLayer(function (layer) {
            drawnItems.removeLayer(layer);
        });

        let type = e.layerType,
            layer = e.layer;

        if (type === 'circle') {
            geofenceFormData['type'] = 0;
            geofenceFormData['radius'] = layer.getRadius();
            geofenceFormData['center_lat'] = layer.getLatLng().lat;
            geofenceFormData['center_lon'] = layer.getLatLng().lng;
        } else if (type === 'polygon') {
            geofenceFormData['type'] = 1;
            geofenceFormData['polygon_coordinates'] = layer.getLatLngs()[0];
        }
        drawnItems.addLayer(layer);
    });

    map.on('draw:edited', function (e) {
        e.layers.eachLayer(function (layer) {
            if (layer instanceof L.Circle) {
                geofenceFormData['type'] = 0;
                geofenceFormData['radius'] = layer.getRadius();
                geofenceFormData['center_lat'] = layer.getLatLng().lat;
                geofenceFormData['center_lon'] = layer.getLatLng().lng;
            } else if (layer instanceof L.Polygon) {
                geofenceFormData['type'] = 1;
                geofenceFormData['polygon_coordinates'] = layer.getLatLngs()[0];
            }
        });
    });

    map.on('draw:deleted', function (e) {
        drawnItems.eachLayer(function (layer) {
            drawnItems.removeLayer(layer);
        });
        geofenceFormData['type'] = 0;
        geofenceFormData['radius'] = null;
        geofenceFormData['center_lat'] = null;
        geofenceFormData['center_lon'] = null;
        geofenceFormData['polygon_coordinates'] = null;
    });
}
const updateMovementFifoThreshold = () => {
    if (!generalFormData['movement_instantaneous_fifo_threshold']) {
        generalFormData['movement_instantaneous_fifo_threshold'] = generalFormData['fifo_movement_start_thresholds'];
    }
}


const storeTemplate = () => {
    errors.value = [];
    let data = null;
    switch (props.type.toLowerCase()) {
        case 'geofence':
            data = geofenceFormData;
            if (!geofenceFormData['label']) {
                errors.value.push("Label field is required");
            }
            if (geofenceFormData['type'] === 0) {
                if (!geofenceFormData['radius'] || !geofenceFormData['center_lat'] || !geofenceFormData['center_lat']) {
                    errors.value.push("You must draw circle on map");
                }
            } else {
                if (!geofenceFormData['polygon_coordinates']) {
                    errors.value.push("You must draw polygon on map");
                }
                if (geofenceFormData['polygon_coordinates'].length > 32) {
                    errors.value.push("Polygon can have max 32 points");
                }
            }
            break
        case 'light':
            data = lightSensorFormData;
            if (!lightSensorFormData['label']) {
                errors.value.push("Label field is required");
            }
            if (!lightSensorFormData['light_profile']) {
                errors.value.push("You must select one of the light profile");
            }
            break
        case 'temperature':
            data = temperatureSensorFormData;
            if (!temperatureSensorFormData['label']) {
                errors.value.push("Label field is required");
            }
            if (temperatureSensorFormData['low_threshold_celsius'] === null || temperatureSensorFormData['low_threshold_celsius'] === '') {
                errors.value.push("Low threshold field is required");
            }
            if (temperatureSensorFormData['high_threshold_celsius'] === null || temperatureSensorFormData['high_threshold_celsius'] === '') {
                errors.value.push("High threshold field is required");
            }
            break
        case 'ble_tag':
        case 'wifi_tag':
            data = bleWifiFormData;
            if (!bleWifiFormData['type'] ||
                !bleWifiFormData['label'] ||
                !bleWifiFormData['scan_interval_in_seconds'] ||
                !bleWifiFormData['scan_window_in_seconds'] ||
                !bleWifiFormData['minimum_rssi_threshold'] ||
                !bleWifiFormData['debounce_interval_in_seconds'] ||
                !bleWifiFormData['reporting_interval_in_seconds'] ||
                !bleWifiFormData['name_prefixes'] ||
                !bleWifiFormData['address_prefixes']?.length
            ) {
                errors.value.push("All fields are required");
            }
            break
        case 'speed':
            data = {...speedFormData, speed_threshold: displayToMph(speedFormData['speed_threshold'])};
            if (!speedFormData['label'] || !speedFormData['speed_threshold'] || !speedFormData['minimum_violations_in_seconds'] || !speedFormData['minimum_alert_interval_seconds']) {
                errors.value.push("All fields are required");
            }
            break
        case 'push_button':
            data = pushButtonFormData;
            if (!pushButtonFormData['label'] || !pushButtonFormData['debounce_interval'] || !pushButtonFormData['report_interval']) {
                errors.value.push("Label & Interval fields are required");
            }
            break
        case 'io': {
            const { valid: _ioValid, ...ioPayload } = extGpioFormData;
            data = {
                ...ioPayload,
                gpo_output: ioPayload.gpo_output ? 1 : 0,
                gpo_default_state: ioPayload.gpo_default_state ? 1 : 0,
            };
            if (!extGpioFormData['label']) {
                errors.value.push("Template name is required");
            }
            // B7: at least one of input or output must be enabled, otherwise the template is a no-op
            if (!extGpioFormData['gpi'] && !extGpioFormData['gpo']) {
                errors.value.push("Enable at least one of digital input or digital output");
            }
            if (extGpioFormData['gpi']) {
                // B26: parity with mobile/firmware ranges. Treat non-finite values
                // (blank, NaN) as invalid rather than letting Number(0) short-circuit
                // past the range check.
                const debounce = Number(extGpioFormData['gpi_debounce_interval']);
                if (!Number.isFinite(debounce) || debounce < 1 || debounce > 255) {
                    errors.value.push("Input filter must be between 1 and 255 ms");
                }
                const reportInt = Number(extGpioFormData['gpi_report_interval']);
                if (!Number.isFinite(reportInt) || reportInt < 1 || reportInt > 65535) {
                    errors.value.push("Cooldown between events must be between 1 and 65535 ms");
                }
            }
            // CB5: catch sub-100 periods client-side so customers see the limit before the round-trip
            const periodMs = Number(extGpioFormData['ext_gpi_motion_period_ms']);
            const widthMs = Number(extGpioFormData['ext_gpi_motion_pulse_width_ms']);
            if (periodMs > 0 && periodMs < 100) {
                errors.value.push("Pulse period must be 0 (default) or at least 100 ms");
            }
            // B7: pulse-on-start/end is mutually exclusive with sustain/beacon during motion
            const pulseStart = Number(extGpioFormData['ext_gpi_motion_pulse_start']);
            const pulseStop = Number(extGpioFormData['ext_gpi_motion_pulse_stop']);
            const during = Number(extGpioFormData['ext_gpi_motion_during']);
            if ((pulseStart === 1 || pulseStop === 1) && during !== 0) {
                errors.value.push("Pulse-on-start/end cannot be combined with Sustain or Beacon during motion");
            }
            if (pulseStart === 1 && widthMs === 0) {
                errors.value.push("Pulse width must be greater than zero when pulse-on-start is enabled");
            }
            if (widthMs > 0 && periodMs > 0 && widthMs >= periodMs) {
                errors.value.push("Pulse width must be less than period for beacon mode");
            }
            // Belt-and-braces: the legacy gpo_output flag is mutually exclusive with
            // every motion field, mirroring the API validator added in PR #871. The
            // preset emitter clears gpo_output, but Advanced mode can still leave it
            // set, so flag it here for a clean client-side error rather than a 422.
            if (extGpioFormData['gpo_output'] && (during !== 0 || pulseStart === 1 || pulseStop === 1)) {
                errors.value.push("Legacy 'Drive output while moving' cannot be combined with motion presets. Pick a single behaviour.");
            }
            break
        }
        default:
            data = generalFormData;
            break
    }

    if (errors.value.length) {
        document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        return false;
    }

    send('post', `${urlPrefix.value}-templates`, data)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('addTemplate', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
